import { render, staticRenderFns } from "./generalization-detail.vue?vue&type=template&id=4cb2eb42&scoped=true"
import script from "./generalization-detail.vue?vue&type=script&lang=js"
export * from "./generalization-detail.vue?vue&type=script&lang=js"
import style0 from "./generalization-detail.vue?vue&type=style&index=0&id=4cb2eb42&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb2eb42",
  null
  
)

export default component.exports